import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';

const BasicCheckboxTemplate = function({ id, label, checked, onChange, t, disabled, className }) {
    return (
        <React.Fragment>
            <input
                id={id}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                type='checkbox'
                className= {(className != null || className != undefined) ? className : 'input--check'}
            />
            <label htmlFor={id}>
                {t(label)}
            </label>
        </React.Fragment>
    );
};

BasicCheckboxTemplate.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    className: PropTypes.string,
    t: PropTypes.func
};

BasicCheckboxTemplate.defaultProps = {
    disabled: false
};

export default defaultTemplate(BasicCheckboxTemplate);
